export default "__VITE_ASSET__DMBDL4S6__"